// listingTypes.js
// Listing types for property — used in SelectRole.jsx Step 2
// Only applies to property flow (project has no listing type step)

const listingTypes = [
  {
    id:          "sale",
    label:       "For Sale",
    description: "Publish your property for buyers looking to invest or purchase.",
  },
  {
    id:          "rent",
    label:       "For Rent",
    description: "List your property for tenants searching for rental or lease spaces.",
  },
];

export default listingTypes;